module.exports = __webpack_public_path__ + "assets/images/pages/workshops/form-image.png?affad3ca";